import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { PerfilRiesgo } from '../../../_models/perfil-riesgo';
import { ListaItem } from '../../../_models/lista-item';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { ProductoRenovacion } from '../../../_models/producto-renovacion';
import { Nivel } from '../../../_models/nivel';
import { ProductoRenovacionService } from '../../../_services/producto-renovacion.service';
import { NivelesService } from '../../../_services/niveles.service';

@Component( {
  selector: 'app-producto-renovacion',
  templateUrl: 'producto-renovacion.component.html'
} )

export class ProductoRenovacionComponent implements OnInit {
  @Input() producto: Producto;
  carInformacionInicial = true;
  lisProductosRenovaciones: ProductoRenovacion[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  ranIncorrecto = false;
  cuoIncorrecto = false;
  lisPerfiles: SelectItem[] = [];
  lisFrecuencia: SelectItem[] = [];
  lisNivelAprueba: SelectItem[] = [];
  lisNivelExcepcion: SelectItem[] = [];
  lisPerfilesTodos: PerfilRiesgo[] = [];
  lisFrecuenciaTodos: ListaItem[] = [];
  lisNivelesTodos: Nivel[] = [];
  proIgual = false;

  constructor( private proRenovacionServicio: ProductoRenovacionService,
               private navServicio: NavService,
               private location: Location,
               private fb: FormBuilder,
               private perRiesgoServicio: PerfilRiesgoService,
               private lisServicio: ListaService,
               private nivServicio: NivelesService,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreFrecuenciaProducto', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_FRECUENCIA' ), sort: false },
      { field: 'rangoPlazo', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_PLAZOCREDITO' ), sort: false },
      { field: 'minimoCuotasPagas', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_CUOTASPAGAR' ), sort: false },
      { field: 'perfilRiesgo', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_PERFIL' ), sort: false },
      { field: 'nivelAprueba', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_NIVELAPRUEBA' ), sort: false },
      { field: 'nivelExcepcion', header: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.LBL_NIVELEXCEPCION' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];


    forkJoin( this.proRenovacionServicio.listadoPorProducto( this.producto.idProducto ), this.lisServicio.getMasterDetails( ' ListasFrecuenciasProductos' ), this.perRiesgoServicio.listadoHabilitados(), this.nivServicio.listado() ).subscribe( ( [ lisProductosRenovaciones, lisFrecuencias, lisPerfiles, lisNiveles ] ) => {

      lisProductosRenovaciones.map( ( s: ProductoRenovacion ) => {
        if ( !s.idPerfilRiesgo ) {
          s.perfilRiesgo = this.navServicio.buscarMensaje( 'LBL_TODOS' );
        }
        s.rangoPlazo = s.plazoMinimo + ' - ' + s.plazoMaximo;
        this.lisProductosRenovaciones.push( s );
      } );

      this.lisFrecuenciaTodos = lisFrecuencias;
      this.lisPerfilesTodos = lisPerfiles;
      this.lisNivelesTodos = lisNiveles.filter( x => x.indicadorAprueba );
      this.cargarFormulario();
      this.cargarComboInicial();
      this.carInformacionInicial = false;
    } );

  }

  cargarComboInicial() {
    this.lisFrecuencia = [];
    this.lisFrecuenciaTodos.map( ( s: ListaItem ) => {
      this.lisFrecuencia.push( { label: s.nombre, value: s.idLista } );
    } );

    this.lisPerfiles = [];
    this.lisPerfiles.push( { label: this.navServicio.buscarMensaje( 'LBL_TODOS' ), value: 0 } );
    this.lisPerfilesTodos.map( ( s: PerfilRiesgo ) => {
      this.lisPerfiles.push( { label: s.nombreRiesgo, value: s.idPerfilRiesgo } );
    } );

    this.lisNivelAprueba = [];
    this.lisNivelesTodos.map( ( s: Nivel ) => {
      this.lisNivelAprueba.push( { label: s.nombre, value: s.idNivel } );
    } );
  }

  cargarNivelExcepcion( idNivelAprueba: string ) {
    this.lisNivelExcepcion = [];
    const a = this.lisNivelesTodos.find( x => x.idNivel === idNivelAprueba );
    if ( a ) {
      this.lisNivelesTodos.map( ( s: Nivel ) => {
        if ( s.codigo >= a.codigo ) {
          this.lisNivelExcepcion.push( { label: s.nombre, value: s.idNivel } );
        }
      } );
    }
    this.f.idNivelExcepcion.setValue( null );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoRenovacion: [ null ],
      idFrecuenciaProducto: [ null, [ Validators.required ] ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idPerfilRiesgo: [ null ],
      idNivelAprueba: [ null, [ Validators.required ] ],
      idNivelExcepcion: [ null, [ Validators.required ] ],
      plazoMinimo: [ null, [ Validators.required, Validators.maxLength( 2 ) ] ],
      plazoMaximo: [ null, [ Validators.required, Validators.maxLength( 2 ) ] ],
      minimoCuotasPagas: [ null, [ Validators.required, Validators.maxLength( 2 ) ] ],
      indicadorHabilitado: [ true ],
      auditoriaUsuario: [ null ],
      auditoriaFecha: [ null ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  inhabilitar( proRenovacion: ProductoRenovacion ) {
    if ( this.producto.indicadorHabilitado && this.lisProductosRenovaciones.length == 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'renovacion',
        accept: () => {
          this.carInformacionInicial = true;
          proRenovacion.indicadorHabilitado = false;
          this.proRenovacionServicio.actualizar( proRenovacion ).subscribe( regActualizado => {
            const a = this.lisProductosRenovaciones.findIndex( x => x.idProductoRenovacion === proRenovacion.idProductoRenovacion );
            if ( a >= 0 ) {
              this.lisProductosRenovaciones.splice( a, 1 );
            }
            this.carInformacionInicial = false;
          } );
        },
        reject: () => {
        }
      } );
    }

  }

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    this.validarCuotas();
    this.validarPlazo();
    if ( this.formulario.valid && !this.ranIncorrecto && !this.cuoIncorrecto ) {
      this.guardando = true;
      const proRenovacion = this.formulario.value;

      if ( proRenovacion.idPerfilRiesgo === 0 ) {
        proRenovacion.idPerfilRiesgo = null;
      }

      this.validarIgualdad( this.lisProductosRenovaciones, proRenovacion );
      if ( !this.proIgual ) {
        this.proRenovacionServicio.crear( proRenovacion ).subscribe( renovacion => {
          proRenovacion.idProductoRenovacion = renovacion.idProductoRenovacion;

          if ( proRenovacion.idPerfilRiesgo ) {
            const a = this.lisPerfilesTodos.find( x => x.idPerfilRiesgo === proRenovacion.idPerfilRiesgo );
            if ( a ) {
              proRenovacion.perfilRiesgo = a.nombreRiesgo;
            }
          } else {
            proRenovacion.perfilRiesgo = this.navServicio.buscarMensaje( 'LBL_TODOS' );
          }

          proRenovacion.rangoPlazo = proRenovacion.plazoMinimo + ' - ' + proRenovacion.plazoMaximo;

          const b = this.lisFrecuenciaTodos.find( x => x.idLista === proRenovacion.idFrecuenciaProducto );
          if ( b ) {
            proRenovacion.nombreFrecuenciaProducto = b.nombre;
          }

          const c = this.lisNivelesTodos.find( x => x.idNivel === proRenovacion.idNivelAprueba );
          if ( c ) {
            proRenovacion.nivelAprueba = c.nombre;
          }

          const d = this.lisNivelesTodos.find( x => x.idNivel === proRenovacion.idNivelExcepcion );
          if ( d ) {
            proRenovacion.nivelExcepcion = d.nombre;
          }

          // this.lisProductosRenovaciones.push( proRenovacion );
          this.lisProductosRenovaciones = [ ...this.lisProductosRenovaciones, proRenovacion ];
          this.formulario.reset();
          this.f.idProducto.setValue( this.producto.idProducto );
          this.f.indicadorHabilitado.setValue( true );
          this.lisNivelExcepcion = [];
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTORENOVACION.MSG_SONIGUALES' )
        } );
        this.guardando = false;
      }

    }
  }

  validarCuotas() {
    const inferior = this.f.plazoMinimo.value;
    const superior = this.f.plazoMaximo.value;
    const cuota = this.f.minimoCuotasPagas.value;
    this.cuoIncorrecto = (inferior && superior && cuota && (Number(cuota) > Number(superior) || Number(cuota) < Number(inferior))) ? true : false;
  }

  validarPlazo() {
    const inferior = this.f.plazoMinimo.value;
    const superior = this.f.plazoMaximo.value;
    this.ranIncorrecto = (inferior && superior && Number(inferior) >= Number(superior)) ? true : false;
  }

  validarIgualdad( listado: ProductoRenovacion[], objComparar: ProductoRenovacion ) {
    const atrIguales = [ 'idFrecuenciaProducto', 'idPerfilRiesgo', 'idNivelAprueba', 'idNivelExcepcion', 'plazoMinimo', 'plazoMaximo', 'minimoCuotasPagas' ];
    this.proIgual = listado.find( x => atrIguales.filter( y => x[ y ] == objComparar[ y ] ).length === atrIguales.length ) ? true : false;
  }
}
